<template>
  <div>
    <p v-if=" type == 9 || type == 10 ">
      {{ title }}{{ codeNum }}
      <span v-show="isCopy" class="copy-btn" :data-clipboard-text="codeNum" ref="copy" @click="copyFrom">复制</span>
      <span v-show="!isCopy" class="btn" @click="getPlan()">查看</span>
    </p>
    <div v-if=" type == 11 || type == 12" style="width: 80px; height: 80px;">
      <el-image fit="fill" style="width: 80px; height: 80px;" :src="url" @click="getPlan()" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
    </div>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import { getPlainInfo } from "@/api/url";
import Clipboard from "clipboard";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "GetPlain",
  props: {
    title: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
      default: '',
    },
    //type：9=手机号，10=身份证号，11=微信二维码，12=身份证图片
    type: {
      type: Number,
      default: 9,
    },
    //subType：type=10的时需传值，1=获取手机身份证号，2=获取芝麻认证身份证号，3=获取百度认证身份证号，4=获取认证通过的身份证号
    subType: {
      type: Number,
      default: 0,
    },
    //图片链接
    url: {
      type: String,
      default: '',
    },
    //身份证正反
    side: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      codeNum: this.code,
      isCopy: false,
      imgUrl: this.url,
    }
  },
  watch: {
    uid() {
      this.codeNum = this.code;
      this.imgUrl = this.url
      this.isCopy = false;
    }
  },
  methods: {
    getPlan() {
      let param = {}
      param['uid'] = this.uid;
      param['type'] = this.type;
      param['subType'] = this.subType;
      getFormData( getPlainInfo, param ).then((data)=>{
        let {code, msg} = data;
        if( code == 200 ) {
          if ( this.type == 9  ) {
            this.codeNum = data.data.phone;
            this.isCopy = true;
          }
          if ( this.type == 10 ) {
            this.codeNum = data.data.identityCode;
            this.isCopy = true;
          }
          if ( this.type == 11 ) {
            this.showImg(data.data.wechatImg)
          }
          if ( this.type == 12 ) {
            if( this.side == 0 ) {
              this.showImg(data.data.identityImgF)
            }else {
              this.showImg(data.data.identityImgZ)
            }
          }
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(()=>{

      })
    },

    //复制
    copyFrom(){
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy() //使用destroy可以清除缓存
      })
      clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        clipboard.destroy()
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },

  },
}
</script>

<style scoped>
.btn {
  color: #409eff;
  cursor: pointer;
}
.copy-btn {
  color: #42b983;
  cursor: pointer;
}
</style>
